import React from 'react';
import ThemeProvider from 'providers/ThemeProvider';
import CommandPalette from 'components/common/CommandPalette';
import { inject } from '@vercel/analytics';
import './src/styles/global.css';
import DevRibbon from 'components/common/DevRibbon';

console.log(React.version);

// Initialize Vercel Analytics in the browser
inject();

export const onServiceWorkerUpdateReady = () => window.location.reload(true);

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider>
      {element}
      <CommandPalette />
      <DevRibbon />
    </ThemeProvider>
  );
};
